/**
 * Client portal read hooks — one per /portal/* list or record, cached under
 * portalKeys. `projectId` narrows a list to one project.
 */

import { useQuery } from '@tanstack/react-query';

import { retryUnlessNotLinked } from '../portalNotLinked';
import * as portal from '../services/portal.service';
import { portalKeys } from './portalKeys';

export const usePortalMe = () =>
  useQuery({ queryKey: portalKeys.me(), queryFn: portal.getPortalMe, staleTime: 60_000, retry: retryUnlessNotLinked });

export const usePortalProject = (id: string) =>
  useQuery({ queryKey: portalKeys.project(id), queryFn: () => portal.getPortalProject(id), enabled: Boolean(id) });

export const usePortalInvoices = (projectId?: string) =>
  useQuery({ queryKey: portalKeys.invoices(projectId), queryFn: () => portal.listPortalInvoices(projectId) });

export const usePortalReceipts = () => useQuery({ queryKey: portalKeys.receipts(), queryFn: portal.listPortalReceipts });

export const usePortalPurchases = (projectId?: string) =>
  useQuery({ queryKey: portalKeys.purchases(projectId), queryFn: () => portal.listPortalPurchases(projectId) });

export const usePortalApprovals = (projectId?: string) =>
  useQuery({ queryKey: portalKeys.approvals(projectId), queryFn: () => portal.listPortalApprovals(projectId) });

export const usePortalApproval = (id: string) =>
  useQuery({ queryKey: portalKeys.approval(id), queryFn: () => portal.getPortalApproval(id), enabled: Boolean(id) });

export const usePortalDocuments = (projectId?: string) =>
  useQuery({ queryKey: portalKeys.documents(projectId), queryFn: () => portal.listPortalDocuments(projectId) });

export const usePortalMoodboards = (projectId?: string) =>
  useQuery({ queryKey: portalKeys.moodboards(projectId), queryFn: () => portal.listPortalMoodboards(projectId) });
